import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { amountFormatter, getAllProperties, getAllPYPByUser } from "services";
import DashboardLayout from "./DashboardLayout";
import PostedPropertyCard from "../../postYourProperty/PostedPropertyCard";
import { DateTime } from "luxon";

export const PostedPropertiesSection = () => {
  const [propertiesData, setPropertiesData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
  const [noMoreData, setNoMoreData] = useState(false);
  const user_uuid = useSelector((state: any) => {
    return state.auth?.user?.uuid;
  });

  const getProperties = async (pageToFetch: number) => {
    if (isFetchingNextPage || noMoreData) return;
    setIsFetchingNextPage(true);

    const data: any = await getAllPYPByUser(user_uuid, pageToFetch);

    if (data.data && data.data.length > 0) {
      setPropertiesData((prev: any) => [...prev, ...data.data]);
      if (data.data.length < 5) {
        setNoMoreData(true);
      }
    } else {
      setNoMoreData(true);
    }
    setIsFetchingNextPage(false);
  };

  useEffect(() => {
    getProperties(page);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;

      const scrolledToBottom =
        Math.ceil(scrollTop + clientHeight) >= scrollHeight - 1300;

      if (scrolledToBottom && !isFetchingNextPage && !noMoreData) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFetchingNextPage, noMoreData]);

  return (
    <>
      <DashboardLayout>
        {propertiesData?.length > 0 ? (
          <div className="space-y-8 flex flex-col md:inline-block md:flex-none md:w-full  md:items-start  items-center">
            {propertiesData.map((property: any, index: number) => (
              <PostedPropertyCard
                className=" bg-brand-lightPink flex flex-col md:flex-row max-w-[358px] lg:flex-col mid:flex-row md:max-w-[951px] 2xl:lg:max-w-[1251px] lg:relative hover:shadow-lg hover:shadow-300 hover:duration-300 hover:ease-out clip-path-mobileClipPolygonTopRight md:clip-path-webClipPolygonTopRight"
                imgClasses="lg:w-full mid:w-[293px]"
                key={`property-${index}`}
                propertyData={property}
                assetPath={"/newPropertyImage.png"}
                showPrice={
                  property.property_date_type === "undated" ? false : true
                }
                price={amountFormatter(
                  property?.json_form_data?.reservePrice
                    ? property?.json_form_data?.reservePrice
                    : property?.json_form_data?.basePriceProposedLastRp
                    ? property?.json_form_data?.basePriceProposedLastRp
                    : property?.json_form_data?.propertyCost
                )}
                priceTag={
                  property?.json_form_data?.reservePrice
                    ? "reserve Price"
                    : "Base Price"
                }
                isTagged={true}
                showTagText={true}
                tag={property?.status}
                listingId={
                  property?.property_listing_id
                    ? property?.property_listing_id
                    : property?.listing_id
                    ? `Temp ${property?.listing_id}`
                    : ""
                }
                location={`${property?.json_form_data?.locality ?? "N/A"}, ${
                  property?.json_form_data?.city?.label ?? "N/A"
                }`}
                propertyInfo={property?.json_form_data?.description}
                propertyType={`${
                  property?.json_form_data?.propertyType?.title ?? "N/A"
                } / ${
                  property?.json_form_data?.subPropertyType?.title ?? "N/A"
                }`}
                carpetArea={
                  property?.json_form_data?.builtUpArea
                    ? property?.json_form_data?.builtUpArea + " sq ft"
                    : "N/A"
                }
                deadlineDate={
                  property?.json_form_data?.lastDateForBidsAndEmd
                    ? property?.json_form_data?.lastDateForBidsAndEmd
                    : "N/A"
                }
                auctionDate={property?.json_form_data?.dateOfAuction?.date}
              />
            ))}
            {isFetchingNextPage && (
              <div className="flex justify-center items-center">
                <div className="w-14 h-14 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
              </div>
            )}
          </div>
        ) : (
          <>
            <div className="font-spaceGrotesk font-normal text-mobile-subheading leading-4 lg:text-[30px] mid:text-[36px] text-center lg:mt-14  lg:leading-[48px]  lg:pl-[19px] py-2 lg:py-3   ">
              No Properties Posted
            </div>
          </>
        )}
      </DashboardLayout>
    </>
  );
};

export default PostedPropertiesSection;
